import { Modal } from './Modal.js';

/**
 * Rückfrage vor einer Handlung, die sich nicht rückgängig machen lässt.
 *
 * Der bestätigende Knopf trägt die Handlung im Text („Entfernen"), nicht ein
 * blasses „OK": Wer nur die Knöpfe liest, soll trotzdem wissen, was gleich
 * geschieht.
 */
interface ConfirmDialogProps {
  isOpen: boolean;
  title: string;
  message: React.ReactNode;
  confirmLabel: string;
  isPending?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmDialog = ({
  isOpen,
  title,
  message,
  confirmLabel,
  isPending = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps): React.JSX.Element => (
  <Modal
    isOpen={isOpen}
    title={title}
    onClose={onCancel}
    actions={
      <>
        <button type="button" onClick={onCancel} disabled={isPending}>
          Abbrechen
        </button>
        <button
          type="button"
          className="button-danger-solid"
          onClick={onConfirm}
          disabled={isPending}
        >
          {isPending ? 'Entfernt …' : confirmLabel}
        </button>
      </>
    }
  >
    {message}
  </Modal>
);
